class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    // VATA Living: de melding sluit zichzelf automatisch na ca. 6,5s
    // (binnen de gevraagde 5-7s), tenzij de klant er met muis of
    // toetsenbord in zit — dan pauzeert de timer tot de klant weggaat.
    // De handmatige sluitknop (hierboven) blijft daarnaast gewoon werken.
    this.autoCloseDelay = 6500;
    this.autoCloseTimer = null;
    this.notification.addEventListener('mouseenter', () => this.pauseAutoClose());
    this.notification.addEventListener('mouseleave', () => this.resumeAutoClose());
    this.notification.addEventListener('focusin', () => this.pauseAutoClose());
    this.notification.addEventListener('focusout', () => this.resumeAutoClose());
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
    this.startAutoClose();
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
    this.clearAutoClose();

    removeTrapFocus(this.activeElement);
  }

  startAutoClose() {
    this.clearAutoClose();
    this.autoCloseTimer = setTimeout(() => this.close(), this.autoCloseDelay);
  }

  clearAutoClose() {
    if (this.autoCloseTimer) {
      clearTimeout(this.autoCloseTimer);
      this.autoCloseTimer = null;
    }
  }

  pauseAutoClose() {
    this.clearAutoClose();
  }

  resumeAutoClose() {
    if (this.notification.classList.contains('active')) this.startAutoClose();
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.updateOneProductPromo();
    this.open();
    

  }
async updateOneProductPromo() {
    const promo = this.querySelector('#cart-notification-promo');
    const message = this.querySelector('#cart-notification-promo-message');
    if (!promo || !message) return;
    promo.hidden = true;
    const currentRequest = (this.promoRequestNumber = (this.promoRequestNumber || 0) + 1);
    try {
      const response = await fetch(`${routes.cart_url}.js`, { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      if (currentRequest !== this.promoRequestNumber || !this.notification.classList.contains('active')) return;
      if (cart.item_count === 1 && cart.items.length === 1) {
        message.textContent = 'Kies nog een product en krijg €5 korting';
        promo.hidden = false;
      }
    } catch (error) {
      console.error('Winkelwagenpromotie kon niet worden geladen', error);
    }
  }


  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

}

customElements.define('cart-notification', CartNotification);
